import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	Checkbox,
	Tooltip,
	Select,
	Functions
} from "rhombus-react";

import { loadAdvertiserObjectives } from "reducers/AdvertiserDetails";
import { TARGET_METHODS } from "utils/constants";


export default function ModernSelection(props){
	let {
			onChange,
			currentValue,
			onObjective,
			selectedObjective,
		} = props
		, dispatch = useDispatch()
		;

	function handleChange(e){
		if(e.target.checked){
			onChange(e.target.value);
		} else {
			onChange(TARGET_METHODS.MODERN);
		}
	}
	let $audLabel = (
		<React.Fragment>
			Enable Audience Optimization
			<Tooltip description="Optimized to deliver the best version to a user based on audience data."
				direction="top"
				size="large"
			/>
		</React.Fragment>
	);

	let {
		advertiserObjectives,
		advertiserId,
	} = useSelector((state) => {
		return {
			advertiserObjectives: getActiveAdvertiserObjectives(state.advertiserDetails.objectives?.items),
			advertiserId:state.advertiserDetails.data.id,
		};
	});

	useEffect(() => {
		return dispatch(loadAdvertiserObjectives(advertiserId));
	}, [advertiserId]);

	function getActiveAdvertiserObjectives(objs = []) {
		return objs.filter(obj => obj?.status === "Active").map((obj) => {
			const { id, name } = obj;
			return { value: { id }, label: `${name} (${id})` };
		});
	}

	return (
		<div className="radio-options">
			<Select
				label="Advertiser Objective"
				placeholder="Select Advertiser Objective"
				options={advertiserObjectives}
				onChange={val => onObjective(val)}
				value={selectedObjective}
				onMenuScrollToBottom={Functions.noop}
			/>
			<Checkbox
				className="audience-checkbox"
				label    = {$audLabel}
				key      = "modern audience"
				type     = "checkbox"
				onChange = {handleChange}
				value    = {TARGET_METHODS.MODERN_AUDIENCE}
				checked  = {TARGET_METHODS.MODERN_AUDIENCE === currentValue}
			/>
		</div>
	);
}
